import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Button from "../common/Button";
import Fieldset from "../common/Fieldset";
import Form from "../common/Form";
import Section from "../common/Section";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../actions/layoutActions";
import * as types from "../../constants/ComponentConstants";

import redirector from "../../util/redirector.js";
import SimulatieDossierPageHelper from "../simulatiedossier/SimulatieDossierPageHelper";

class SimulatieBevestigingPage extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			simulatieDossier: null
		};
	}

	// ----------------------------------------------------------------------------
	componentWillMount() {
		const { simulatieDossierId, loadLayout } = this.props;

		this.pageHelper = new SimulatieDossierPageHelper(this, redirector);
		if(!this.state.simulatieDossier)
			this.pageHelper.getSimulatieDossier(simulatieDossierId);

		if (!simulatieDossierId)
			redirector.goToNotFound();
		else
			loadLayout(
				"Simulatiedossier aangemaakt",
				simulatieDossierId
			);
	}

	// ----------------------------------------------------------------------------
	isReadyToRender() {
		return true;
	}

	gaVerder() {
		if(this.state.simulatieDossier)
		{
			const simulatieDossier = this.state.simulatieDossier;
			const simulatieDossierId = simulatieDossier.id;

			const infrastructuren = simulatieDossier.sportinfrastructurenInDeBuurt.filter(i => i.infrastructuurId !== "00000000-0000-0000-0000-000000000000");
			const infrastructuurId = infrastructuren[0].infrastructuurId;

			return function () {
				redirector.goTo('/simulatiedossier/' + simulatieDossierId + '/infrastructuur/' + infrastructuurId);
			};
		}
		else
			return null;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}

		return (
			<Section title="Ga verder" color={types.COLOR_BLUE}>
				<Form
					title="Simulatiedossier aangemaakt"
					name="bevestiging"
					isNotRequired
					rightButtonLabel="Ga verder"
					onRightButtonClick={this.gaVerder()}>
					<Fieldset>
						Via een code die zal opgestuurd worden naar het e-mail adres van
					de contactpersoon kan je dit simulatiedossier later terug oproepen.
				</Fieldset>
				</Form>
			</Section>
		);
	}
}

// ----------------------------------------------------------------------------
SimulatieBevestigingPage.propTypes = {
	loadLayout: PropTypes.func,
	simulatieDossierId: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	let simulatieDossierId = ownProps.params.simulatieDossierId;

	return {
		simulatieDossierId: simulatieDossierId
	};
}
function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadSimulatieBevestigingsLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SimulatieBevestigingPage);